import { gql } from '@apollo/client';

export const EXTRACT_DOCUMENT_TEXT = gql`
  mutation ExtractDocumentText($companyCode: String!, $documentId: Int!) {
    extractDocumentText(companyCode: $companyCode, documentId: $documentId)
  }
`;

export const GET_DOCUMENT_EXTRACTED_TEXT = gql`
  query GetDocumentExtractedText($companyCode: String!, $documentId: Int!) {
    documentExtractedText(companyCode: $companyCode, documentId: $documentId)
  }
`;

export default EXTRACT_DOCUMENT_TEXT;
